import { Box } from "@mui/material";
import { BAY_ITEM_HEIGHT, BAY_ITEM_WIDTH } from "./scrapEyeLayoutCommon";

export const BaySpacer = () => (
  <Box
    sx={{
      width: BAY_ITEM_WIDTH,
      height: BAY_ITEM_HEIGHT,
      borderRadius: 1,
      border: "1px dashed",
      borderColor: "grey.300",
    }}
  />
);
